export default () => {
  return {
    contains: [
      {
        className: "keyword",
        begin: /^msiexec/,
      },
      {
        className: "built_in",
        begin: / \/[a-zA-Z*]+/,
      },
      {
        className: "variable",
        begin: /{[^}]+}/,
      },
      {
        className: "string",
        begin: /MAINTENANCE_KEY=.+/,
      },
      {
        className: "string",
        begin:
          /(INSTALLATION_KEY=|INSTALL_SELF_DEFENCE_DRIVER=|INSTALL_ANTI_TAMPERING_DRIVER=|INSTALL_FILESYSTEM_TELEMETRY_DRIVER=|INSTALL_KERNEL_MODE_DECEPTION_DRIVER=|PROXY_URL_CONFIGURED=|PROXY_URL=)/,
      },
    ],
  };
};
